import React from 'react'
import chat_img from '../../assets/gif/no-data.gif'
const NoDataFound = ({ title }) => {
  return (
    <div className="no-data-found-wrap">
      <img src={chat_img} width={500} />
      <h3>{title || 'Data Not Available'}</h3>
      {/* <p>{"ndustry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only ndustry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only"}</p> */}
    </div>
  )
}
export default NoDataFound
